<div class="qr-error">
  <div class="qr-error__content">
    <app-header />

    <div class="qr-error__main" [class.qr-error__main--centered]="!showRetry()">
      <section class="qr-error__message" aria-labelledby="qr-error-title">
        <img
          class="qr-error__icon"
          src="assets/img/icon-error.svg"
          alt=""
          width="110"
          height="110"
          aria-hidden="true"
        />
        <h1 id="qr-error-title" class="qr-error__title">{{ copy().title }}</h1>
        <p class="qr-error__subtitle">
          {{ copy().subtitle }}
        </p>
      </section>

      @if (showRetry()) {
        <section class="qr-error__action" aria-label="Réessayer le scan">
          <div class="qr-error__retry-card">
            <app-identification-card
              variant="qr"
              [title]="retryCardTitle"
              subtitle=""
              illustrationSrc="assets/img/icon-illustration-qr-phone.svg"
              illustrationAlt="Main tenant un smartphone affichant un QR code"
              (pressed)="retryScan()"
            />
          </div>
        </section>
      }
    </div>

    <app-footer>
      <app-footer-nav [showScrollButton]="false" [backRoute]="scanRoute" />
    </app-footer>
  </div>
</div>
